/**
Project: Voice Panel (c)
Title: Private Route  
Description: Component for hadling the routes of the application which are secure 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React from "react";
import { Route, Redirect } from "react-router-dom";
import axios from "axios";
import { AppURLProps } from "../../core/settings/app-urls";
import { AppConfigProps } from "../../core/settings/app-config";
import TokenUtil from "../../core/helpers/token-util";
import RequestUtil from "../../core/helpers/request-util";
import { isIdentitySessionValid } from "../../core/actions/identity-actions";
import { renewIdentitySession } from "../../core/actions/identity-actions";

const _axiosSource = axios.CancelToken.source();
const _cancelToken = { cancelToken: _axiosSource.token };

export const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        const tokenData = TokenUtil.getIdentitySippioAccessTokenData();
        const isValidSession = isIdentitySessionValid();
        if (tokenData && isEmptyOrNull(tokenData.accountNumber) === true) {
          return <Component {...props} />;
        } else if (
          tokenData &&
          isEmptyOrNull(tokenData.regionsTemplate) === true
        ) {
          return <Component {...props} />;
        } else {
          if (isValidSession === true) {
            RequestUtil.setRequestHeaders();
            if (
              tokenData.tokenExpiry - parseInt(Date.now() / 1000) <=
              AppConfigProps.identitySession.expiryCheckRemainingSeconds
            ) {
              renewIdentitySession(_cancelToken);
            }
            return <Component {...props} />;
          } else {
            TokenUtil.removeIdentityToken();
            return (
              <Redirect
                to={{
                  pathname: AppURLProps.signin,
                  state: { from: props.location },
                }}
              />
            );
          }
        }
      }}
    />
  );
};

// const isNotEmptyOrNull = (value) => (value !== null || value !== "");
const isEmptyOrNull = (value) => value === null || value === "";

export default PrivateRoute;
